module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_iter-step.js
// module id = PECj
// module chunks = 1